import React from "react";
import Cookies from "js-cookie";
import { TokenVerificationLoggedin, ScreenView } from "../utils/tokenVerify";
// import NotFound from "../assets/images/404.svg";

function NoPageComponent() {
    React.useEffect(() => {
        setLoggedIn(Cookies.get("token_xapads_ssp") ? true : false);
        TokenVerificationLoggedin();
        ScreenView();
    }, []);

    const [loggedin, setLoggedIn] = React.useState(false);

    if (loggedin) {
        return (
            <>
                <div style={{ position: "absolute", top: "40%", left: "40%" }} >
                    <div >
                        <div >
                            {/* <img src={NotFound} className="img-fluid" alt="" /> */}
                            <h2>Page Not Found</h2>
                            <p>
                                We're sorry, the page you requested could be not found. <br />{" "}
                                Please go back to Homepage
                            </p>
                            <br />
                            <button className='btn_primary btn w_lg'
                                onClick={() => {
                                    window.location.replace("/dashboard");
                                }}
                            >
                                Go To Home
                            </button>

                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return <></>;
    }
}

export default NoPageComponent;
